import { SUMMARY_ROW_ID } from '@fourthwall/module-analytics';
export const createChartStatsTableConversionRates = (data) => {
    if (!data)
        return [];
    const statsTableData = data.data.timestamps.map((timestamp, index) => ({
        id: timestamp,
        day: timestamp,
        totalSessions: data.data.values[index].totalSessions.value,
        cartCreated: {
            value: data.data.values[index].cartCreated.value,
            percentage: data.data.values[index].cartCreated.percentage,
        },
        checkoutStarted: {
            value: data.data.values[index].checkoutCreated.value,
            percentage: data.data.values[index].checkoutCreated.percentage,
        },
        checkoutPaid: {
            value: data.data.values[index].checkoutPaid.value,
            percentage: data.data.values[index].checkoutPaid.percentage,
        },
        conversionRate: data.data.values[index].checkoutPaid.percentage,
    }));
    if (data.aggregatedValue) {
        statsTableData.unshift({
            id: SUMMARY_ROW_ID,
            day: 'Summary',
            totalSessions: data.aggregatedValue.totalSessions.value,
            cartCreated: {
                value: data.aggregatedValue.cartCreated.value,
                percentage: data.aggregatedValue.cartCreated.percentage,
            },
            checkoutStarted: {
                value: data.aggregatedValue.checkoutCreated.value,
                percentage: data.aggregatedValue.checkoutCreated.percentage,
            },
            checkoutPaid: {
                value: data.aggregatedValue.checkoutPaid.value,
                percentage: data.aggregatedValue.checkoutPaid.percentage,
            },
            conversionRate: data.aggregatedValue.checkoutPaid.percentage,
        });
    }
    return statsTableData;
};
